import { createFormState, hasLength, onlyIntegers } from "redux-freeform";

const formConfig = {
  accountNumber: {
    validators: [],
  },
  amount: {
    validators: [],
  },
  bankLastFour: {
    validators: [],
    constraints: [hasLength(0, 4), onlyIntegers()],
  },
  cardholderName: {
    validators: [],
  },
  bankAccountHolderName: {
    validators: [],
  },
  cardLastFour: {
    validators: [],
    constraints: [hasLength(0, 4), onlyIntegers()],
  },
  transactionId: {
    validators: [],
  },
};

export const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(formConfig);
